import { apiSlice } from "../api/apiSlice";

export const videosApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getVideos: builder.query({
            query: () => `/videos`,
        }),

        getVideo: builder.query({
            query: (id) => `/videos?id=${id}`,
        }),


        addVideo: builder.mutation({
            query: (data) => ({
                url: "/videos",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const videoResponse = await queryFulfilled;
                    if (videoResponse?.data?.id) {
                        dispatch(
                            apiSlice.util.updateQueryData("getVideos", undefined, draft => {
                                draft.push(videoResponse?.data)
                            })
                        )
                    }
                } catch (err) {

                }
            },
        }),

        editVideo: builder.mutation({
            query: ({ id, data }) => ({
                url: `/videos/${id}`,
                method: "PATCH",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const videoResponse = await queryFulfilled;
                    if (videoResponse?.data?.id) {
                        dispatch(
                            apiSlice.util.updateQueryData("getVideos", undefined, draft => {
                                const index = draft.findIndex(v => v.id == arg.id);
                                draft[index] = videoResponse?.data;
                            })
                        );

                        dispatch(
                            apiSlice.util.updateQueryData("getVideo", arg.id, draft => {
                                const index = draft.findIndex(v => v.id == arg.id);
                                draft[index] = videoResponse?.data;
                            })
                        );


                    }
                } catch (err) {

                }
            },
        }),

        deleteVideo: builder.mutation({
            query: (id) => ({
                url: `/videos/${id}`,
                method: "DELETE",
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    await queryFulfilled;
                    dispatch(
                        apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
                            return draft.filter(video => video.id != arg)
                        })
                    )
                } catch (err) {

                }
            },
        }),
    }),
});

export const { useGetVideosQuery, useDeleteVideoMutation, useGetVideoQuery, useAddVideoMutation, useEditVideoMutation } = videosApi;
